import React from "react";
import { isViewVisible } from "../../../utils/ViewSettings";
import MyInboomaView from "./components/MyInboomaView";
import { Biscuit } from "../../../utils";
import Rbac from "../../../utils/Rbac";

export const MyInboomaPage = (props) => {
  return (
    <>
      <MyInboomaView
        name={"myinbooma"}
        dispatch={props.dispatch}
        params={props.params}
        returnPath={props.returnPath}
      />
    </>
  );
};
